// extracted by mini-css-extract-plugin
module.exports = {"privateMessageImage":"PrivateMessageSection_privateMessageImage__2YGYS","closeDiv":"PrivateMessageSection_closeDiv__2NEDJ"};